(function () {
  function initWizoQuiz(section) {
    if (!section || section.dataset.quizReady === 'true') return;
    section.dataset.quizReady = 'true';

    const configEl = section.querySelector('[data-wizo-config]');
    if (!configEl) return;

    const config = JSON.parse(configEl.textContent);
    const questions = config.questions || [];
    const results = config.results || {};
    const guardianOrder = ['Wizo', 'Aural', 'Mnemo', 'Metham', 'Thaal', 'Lumae', 'Orren', 'Xhaal'];

    let current = 0;
    let selected = null;
    let answers = [];
    let score = {};

    const quizCard = section.querySelector('[data-quiz-card]');
    const resultCard = section.querySelector('[data-result-card]');

    const titleEl = section.querySelector('[data-question-title]');
    const stepEl = section.querySelector('[data-step-label]');
    const percentEl = section.querySelector('[data-step-percent]');
    const progressEl = section.querySelector('[data-progress-bar]');
    const optionsEl = section.querySelector('[data-options]');
    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const startBtn = section.querySelector('[data-start]');

    const resultName = section.querySelector('[data-result-name]');
    const resultRole = section.querySelector('[data-result-role]');
    const resultCopy = section.querySelector('[data-result-copy]');
    const resultLink = section.querySelector('[data-result-link]');

    function resetScore() {
      guardianOrder.forEach(name => score[name] = 0);
    }

    function renderQuestion() {
      const q = questions[current];
      selected = answers[current] ?? null;

      quizCard.classList.remove('wizo-v2-fade');
      void quizCard.offsetWidth;
      quizCard.classList.add('wizo-v2-fade');

      stepEl.textContent = `Paso ${current + 1} de ${questions.length}`;
      titleEl.textContent = q.title;

      const percent = Math.round(((current + 1) / questions.length) * 100);
      percentEl.textContent = `${percent}%`;
      progressEl.style.width = `${percent}%`;

      optionsEl.innerHTML = '';
      q.options.forEach((option, idx) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wizo-v2-option' + (selected === idx ? ' is-selected' : '');
        btn.innerHTML = `
          <span>${option.label}</span>
          <span class="wizo-v2-option-dot"></span>
        `;
        btn.addEventListener('click', () => {
          selected = idx;
          answers[current] = idx;
          [...optionsEl.children].forEach(el => el.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          nextBtn.disabled = false;
        });
        optionsEl.appendChild(btn);
      });

      prevBtn.disabled = current === 0;
      nextBtn.disabled = selected === null;
      nextBtn.textContent = current === questions.length - 1 ? 'Ver resultado' : 'Continuar';
    }

    function calculateWinner() {
      resetScore();

      answers.forEach((answerIndex, qIndex) => {
        const picked = questions[qIndex]?.options?.[answerIndex];
        if (picked?.guardian && score[picked.guardian] !== undefined) {
          score[picked.guardian] += 1;
        }
      });

      let winner = guardianOrder[0];
      guardianOrder.forEach(name => {
        if (score[name] > score[winner]) winner = name;
      });

      return winner;
    }

    function showResult() {
      const winner = calculateWinner();
      const data = results[winner] || {};

      resultName.textContent = winner;
      resultRole.textContent = data.role || '';
      resultCopy.textContent = data.copy || '';

      if (data.url) {
        resultLink.href = data.url;
        resultLink.classList.remove('wizo-v2-hidden');
      } else {
        resultLink.classList.add('wizo-v2-hidden');
      }

      resultCard.classList.remove('wizo-v2-hidden');
      resultCard.classList.add('wizo-v2-fade');
      resultCard.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('wizo_quiz_completed', { result: winner });
      }
    }

    prevBtn.addEventListener('click', () => {
      if (current === 0) return;
      current -= 1;
      renderQuestion();
    });

    nextBtn.addEventListener('click', () => {
      if (selected === null) return;

      if (current === questions.length - 1) {
        showResult();
        return;
      }

      current += 1;
      renderQuestion();
    });

    if (startBtn) {
      startBtn.addEventListener('click', () => {
        quizCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    resetScore();
    renderQuestion();
  }

  function bootAll() {
    document.querySelectorAll('[data-wizo-quiz-v2]').forEach(initWizoQuiz);
  }

  document.addEventListener('DOMContentLoaded', bootAll);

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-wizo-quiz-v2]') || event.target;
    initWizoQuiz(section);
  });
})();